import { useRef, useEffect, useState } from 'react';
import { colors } from '../sharedStyles';

export default function Header({ scrollToSection }) {
    const headerRef = useRef(null);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                headerRef.current?.classList.add('scrolled');
            } else {
                headerRef.current?.classList.remove('scrolled');
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleMenuClick = (sectionId) => {
        scrollToSection(sectionId);
        setMenuOpen(false);
    };

    return (
        <header ref={headerRef} style={{ position: 'fixed', width: '100%', top: 0, zIndex: 50, transition: 'all 0.3s ease', backgroundColor: colors.white }}>
            <nav style={{ maxWidth: '80rem', margin: '0 auto', marginTop: '1%', marginBottom: '1%', padding: '0 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', height: '12vh', maxHeight: '100px', minHeight: '60px' }}>
                {/* Logo */}
                <a
                    href="#"
                    onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none', cursor: 'pointer', height: '100%' }}
                >
                    <style>
                        {`
                            .header-logo {
                                height: 85%;
                            }
                            @media (max-width: 768px) {
                                .header-logo {
                                    height: 60% !important;
                                }
                            }
                        `}
                    </style>
                    <img src="/1.svg" alt="L'Equipier Finance" style={{ width: 'auto' }} className="header-logo" />
                </a>

                {/* Navigation Desktop */}
                <div style={{ display: 'none', alignItems: 'center', gap: '2.5rem' }} className="nav-desktop">
                    <button
                        onClick={() => scrollToSection('about')}
                        style={{ transition: 'colors 0.3s', fontWeight: 600, fontSize: '1rem', background: 'none', border: 'none', cursor: 'pointer', color: colors.text }}
                        onMouseEnter={(e) => e.target.style.color = colors.secondary}
                        onMouseLeave={(e) => e.target.style.color = colors.text}
                    >
                        Constat
                    </button>
                    <button
                        onClick={() => scrollToSection('services')}
                        style={{ transition: 'colors 0.3s', fontWeight: 600, fontSize: '1rem', background: 'none', border: 'none', cursor: 'pointer', color: colors.text }}
                        onMouseEnter={(e) => e.target.style.color = colors.secondary}
                        onMouseLeave={(e) => e.target.style.color = colors.text}
                    >
                        Services
                    </button>
                    <button
                        onClick={() => scrollToSection('expertise')}
                        style={{ transition: 'colors 0.3s', fontWeight: 600, fontSize: '1rem', background: 'none', border: 'none', cursor: 'pointer', color: colors.text }}
                        onMouseEnter={(e) => e.target.style.color = colors.secondary}
                        onMouseLeave={(e) => e.target.style.color = colors.text}
                    >
                        Expertise
                    </button>
                    {/* <button
                        onClick={() => scrollToSection('contact')}
                        style={{ transition: 'colors 0.3s', fontWeight: 600, fontSize: '1rem', background: 'none', border: 'none', cursor: 'pointer', color: colors.text }}
                        onMouseEnter={(e) => e.target.style.color = colors.secondary}
                        onMouseLeave={(e) => e.target.style.color = colors.text}
                    >
                        Contact
                    </button> */}
                    <button
                        className="btn-primary"
                        onClick={() => scrollToSection('contact')}
                        style={{
                            padding: '0.75rem 1.75rem',
                            fontWeight: 700
                        }}
                    >
                        Me Contacter
                    </button>
                </div>

                {/* Menu Burger Icon */}
                <div className="burger-menu-container">
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '0.5rem',
                            display: 'flex',
                            marginLeft: 'auto'
                        }}
                    >
                        {menuOpen ? (
                            <svg width="24" height="24" fill="none" stroke={colors.primary} viewBox="0 0 24 24" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        ) : (
                            <svg width="24" height="24" fill="none" stroke={colors.primary} viewBox="0 0 24 24" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"></path>
                            </svg>
                        )}
                    </button>
                </div>
            </nav>

            {/* Mobile Menu */}
            {menuOpen && (
                <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: colors.white,
                    borderBottom: `1px solid ${colors.lightGray}`,
                    padding: '2rem 1.5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1.5rem',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                    animation: 'slideDown 0.3s ease',
                    maxHeight: 'calc(100vh - 80px)', // Limit height just in case, but allow it to shrink
                    overflowY: 'auto'
                }}>
                    <button
                        onClick={() => handleMenuClick('about')}
                        style={{
                            fontWeight: 600,
                            fontSize: '1.25rem',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: colors.text,
                            padding: '0.75rem 0',
                            textAlign: 'left',
                            borderBottom: '1px solid rgba(0,0,0,0.05)',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        Constat
                    </button>
                    <button
                        onClick={() => handleMenuClick('services')}
                        style={{
                            fontWeight: 600,
                            fontSize: '1.25rem',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: colors.text,
                            padding: '0.75rem 0',
                            textAlign: 'left',
                            borderBottom: '1px solid rgba(0,0,0,0.05)',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        Services
                    </button>
                    <button
                        onClick={() => handleMenuClick('expertise')}
                        style={{
                            fontWeight: 600,
                            fontSize: '1.25rem',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: colors.text,
                            padding: '0.75rem 0',
                            textAlign: 'left',
                            borderBottom: '1px solid rgba(0,0,0,0.05)',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        Expertise
                    </button>
                    {/* <button
                        onClick={() => handleMenuClick('contact')}
                        style={{
                            fontWeight: 600,
                            fontSize: '1.25rem',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: colors.text,
                            padding: '0.75rem 0',
                            textAlign: 'left',
                            borderBottom: '1px solid rgba(0,0,0,0.05)',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        Contact
                    </button> */}
                    <button
                        onClick={() => handleMenuClick('contact')}
                        style={{
                            backgroundColor: colors.primary,
                            color: colors.white,
                            padding: '1rem',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '1rem',
                            border: 'none',
                            cursor: 'pointer',
                            marginTop: '1rem',
                            width: '100%'
                        }}
                    >
                        Me Contacter
                    </button>
                </div>
            )}

            <style>{`
                @media (min-width: 992px) {
                    .nav-desktop {
                        display: flex !important;
                    }
                    .burger-menu-container {
                        display: none !important;
                    }
                }
                @media (max-width: 991px) {
                    .nav-desktop {
                        display: none !important;
                    }
                    .burger-menu-container {
                        display: flex !important;
                    }
                }
                
                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </header>
    );
}

